import React, {useState} from 'react';
import {useSelector} from "react-redux";
import {isCurrentUserMemberOf} from "../../../util/bbHelpers";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import {HashLink as Link} from "react-router-hash-link";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

const RegistrationIncompleteDialog=(props)=>{
    const {location, children} = props;

    /*Get state*/
    const {customers, customerInView} = useSelector(({customer}) => customer);
    const authUser = useSelector(({auth}) => auth.authUser);
    const isAdminStaff = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");
    const customer = customers ? customers[customerInView] : null;

    // const history = useHistory();

    const [open, setOpen] = useState(true);

    const noCustomerAssociated = (authUser
            && authUser.customers
            && Array.isArray(authUser.customers)
            && authUser.customers.length === 0)
        && !isAdminStaff;

    const userNotVerified = (authUser
        && authUser.user
        && !authUser.user.is_activated);

    const mfaNotEnabled = authUser
        && authUser.security
        && !authUser.security.mfa_enabled;



    return(
        <>
            {(userNotVerified || noCustomerAssociated) && !isAdminStaff
                ? <Dialog
                    open={open}
                    aria-labelledby="dialog-title"
                    aria-describedby="dialog-description"
                >
                    <DialogTitle id="dialog-title" className={"text-center"}>Your Account Is Not Ready</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="dialog-description">
                            {userNotVerified &&
                            <p>
                                Please verify your email address. If you need another verification email sent, please contact <a href={"mailto:support@breachbits.com"}>support@breachbits.com</a>
                            </p>
                            }

                            {noCustomerAssociated &&
                            <p>
                                You don't have any companies associated with your account, be sure to <Link to={`/confirmNew`}>confirm your company details.</Link>
                                {userNotVerified && <em><small> Your email must be verified to complete this step.</small></em> }
                            </p>
                            }

                            {mfaNotEnabled &&
                            <p>
                                You must <Link to={`/addMFA`}>enable Multi Factor Authentication </Link>to be able to complete registration.
                            </p>}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={()=>setOpen(false)} color="primary">
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
                : null
            }

            {children}
        </>
    )
}

export default RegistrationIncompleteDialog;